import {useEffect,useState} from 'react';
// Live world clocks for the technology footer.
const ZONES:Array<[string,string]>=[['HÀ NỘI','Asia/Ho_Chi_Minh'],['BERLIN','Europe/Berlin'],['TOKYO','Asia/Tokyo']];
function fmt(zone:string,d:Date){return new Intl.DateTimeFormat('en-GB',{timeZone:zone,hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}).format(d)}
export function FooterClock(){
 const [now,setNow]=useState(()=>new Date());
 useEffect(()=>{const t=window.setInterval(()=>setNow(new Date()),1000);return()=>clearInterval(t)},[]);
 return <div className="tf-clock" aria-label="Giờ hiện tại tại Hà Nội, Berlin, Tokyo">{ZONES.map(([name,zone])=><span key={zone}><small>{name}</small><b>{fmt(zone,now)}</b></span>)}</div>
}
export function FooterTicker({items}:{items:string[]}){
 const row=items.concat(items);
 return <div className="tf-ticker" aria-hidden="true"><div className="tf-ticker-track">{[0,1].map(k=><div key={k} className="tf-ticker-row">{row.map((t,i)=><span key={k+'-'+i}><i/>{t}</span>)}</div>)}</div></div>
}
